// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/images/Footer-matching-plat.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
  .Footer_footer__gt4C8 {
    padding: 2rem 5rem; /* Padding for medium and larger screens */
  }
  .Footer_footerColumn__0jEr\\+ {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.Footer_footer-section__s461p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.75rem;
  left: 0; /* Align the footer to the left */
  right: 0; /* Align the footer to the right */
}
}
@media (max-width: 767px) {
  .Footer_justify-content-center__tVWCf {
    text-align: center;
  }
  .Footer_footerColumn__0jEr\\+ {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 50px !important;
}
}

.Footer_footertext__\\+irTJ {
  color: var(--taupe-fonc, #2E2E2E);
  /* Text */
  font-family: "Lato", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
}

.Footer_footerLink__Ag2JE {
    color: #2E2E2E;
    text-decoration: none;
    margin-bottom: 8px;
    transition: color 0.3s;
    font-family: 'Lato';
    font-size: 18px;
    font-weight: 400;
}

.Footer_footerLink__Ag2JE:hover {
    color: #4AAE9B;
    text-decoration: none;
}
a{
  color:#4AAE9B;
}
.Footer_footer-content__WbBZC{
  padding-bottom: 50px;
}

.Footer_word_wrap__LKIS2{
  word-wrap: break-word;
white-space: pre-wrap;
word-break: break-word;
}

@media (max-width: 575px) {
  .Footer_responsive-label__i4vxW {
    padding-bottom: 30px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB,EAAE,0CAA0C;EAChE;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;EACE,yDAAmE;EACnE,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,OAAO,EAAE,iCAAiC;EAC1C,QAAQ,EAAE,kCAAkC;AAC9C;AACA;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;AAChC;AACA;;AAEA;EACE,iCAAiC;EACjC,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB,qBAAqB;AACrB,sBAAsB;AACtB;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF","sourcesContent":["@media (min-width: 768px) {\n  .footer {\n    padding: 2rem 5rem; /* Padding for medium and larger screens */\n  }\n  .footerColumn {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n.footer-section {\n  background-image: url(../../Assets/images/Footer-matching-plat.jpg);\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0.75rem;\n  left: 0; /* Align the footer to the left */\n  right: 0; /* Align the footer to the right */\n}\n}\n@media (max-width: 767px) {\n  .justify-content-center {\n    text-align: center;\n  }\n  .footerColumn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 50px !important;\n}\n}\n\n.footertext {\n  color: var(--taupe-fonc, #2E2E2E);\n  /* Text */\n  font-family: \"Lato\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px; /* 155.556% */\n}\n\n.footerLink {\n    color: #2E2E2E;\n    text-decoration: none;\n    margin-bottom: 8px;\n    transition: color 0.3s;\n    font-family: 'Lato';\n    font-size: 18px;\n    font-weight: 400;\n}\n\n.footerLink:hover {\n    color: #4AAE9B;\n    text-decoration: none;\n}\na{\n  color:#4AAE9B;\n}\n.footer-content{\n  padding-bottom: 50px;\n}\n\n.word_wrap{\n  word-wrap: break-word;\nwhite-space: pre-wrap;\nword-break: break-word;\n}\n\n@media (max-width: 575px) {\n  .responsive-label {\n    padding-bottom: 30px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__gt4C8`,
	"footerColumn": `Footer_footerColumn__0jEr+`,
	"footer-section": `Footer_footer-section__s461p`,
	"justify-content-center": `Footer_justify-content-center__tVWCf`,
	"footertext": `Footer_footertext__+irTJ`,
	"footerLink": `Footer_footerLink__Ag2JE`,
	"footer-content": `Footer_footer-content__WbBZC`,
	"word_wrap": `Footer_word_wrap__LKIS2`,
	"responsive-label": `Footer_responsive-label__i4vxW`
};
export default ___CSS_LOADER_EXPORT___;
